package com.xtream.ui.ui.util.extensions

import androidx.compose.ui.graphics.Color

fun Color.lightenColor( factor: Float): Color {
    val color: Color = this
    val red = (color.red + (1 - color.red) * factor).coerceIn(0f, 1f)
    val green = (color.green + (1 - color.green) * factor).coerceIn(0f, 1f)
    val blue = (color.blue + (1 - color.blue) * factor).coerceIn(0f, 1f)
    return Color(red, green, blue, color.alpha)
}